import DysonV15 from '@app/assets/images/products/v15.png'
import DysonSubmarine from '@app/assets/images/products/submarine.png'
import DysonGen5 from '@app/assets/images/products/gen5.png'
import VacuumImgIt from '@app/assets/images/it/banner-vacuums.png'
import langPacks from '@app/lang'
import { parse } from 'date-fns'
import type { Program } from './programs.types'

const today = new Date()

const italy: Program = {
  id: 'IT',
  urlSegment: 'it',
  supportedLanguages: ['en', 'it'],
  defaultLanguage: 'it',
  languagePack: langPacks.italy,
  products: [
    { name: 'Dyson Gen5detect™ Absolute', img: DysonGen5 },
    { name: 'Dyson V15 Detect™ Absolute', img: DysonV15 },
    { name: 'Dyson V15s Detect Submarine™', img: DysonSubmarine },
  ],
  retailers: [
    'Dyson Store Milano - Gae Aulenti',
    'Dyson Store Milano - City Life',
    'Dyson Store Torino - Le Gru',
    'Dyson Store Roma - Porta di Roma',
    'Dyson Store Venezia - Nave De Vero',
    'Dyson Store Marcianise - Campania',
    'Dyson Store Firenze - I Gigli',
    'Dyson Store Bergamo - OrioCenter',
    'Dyson Store Palermo - Forum Palermo',
    'Dyson Store Carugate - Carosello',
    'Dyson Store Verona - Adigeo',
    'Dyson Store Bologna - Shopville Gran Reno',
    'Dyson Store Napoli - Coin Vomero',
    'Dyson Store Roma - Coin Cola di Rienzo',
    'Dyson Online',
    'Unieuro',
  ],
  startDate: parse('22-04-2024', 'dd-MM-yyyy', new Date()),
  endDate: parse('02-06-2024', 'dd-MM-yyyy', new Date()),
  bannerImg: VacuumImgIt,
  traded_products: [
    { value: 'Dyson' },
    { value: 'Rowenta' },
    { value: 'Hoover' },
    { value: 'Samsung' },
    { value: 'LG' },
    { value: 'Folletto' },
    { value: 'Other', localeKey: 'tradein_q1_option_2' },
  ],
  offer_strategy: 'combined_sku',
  offer_rules: {
    v15: [
      { with: 'Dyson', value: 100 },
      { with: 'Rowenta', value: 100 },
      { with: 'Hoover', value: 100 },
      { with: 'Samsung', value: 100 },
      { with: 'LG', value: 100 },
      { with: 'Folletto', value: 100 },
      { with: 'Other', value: 100 },
    ],
    gen5: [
      { with: 'Dyson', value: 150 },
      { with: 'Rowenta', value: 100 },
      { with: 'Hoover', value: 100 },
      { with: 'Samsung', value: 100 },
      { with: 'LG', value: 100 },
      { with: 'Folletto', value: 100 },
      { with: 'Other', value: 100 },
    ],
    submarine: [
      { with: 'Dyson', value: 150 },
      { with: 'Rowenta', value: 100 },
      { with: 'Hoover', value: 100 },
      { with: 'Samsung', value: 100 },
      { with: 'LG', value: 100 },
      { with: 'Folletto', value: 100 },
      { with: 'Other', value: 100 },
    ],
  },
  closed: today > new Date(CAMPAIGN_END_DATE_IT),
  partner_url: 'https://www.dyson.it/',
  logo_url: 'https://www.dyson.it/it',
}

export default italy
